import {
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
} from './rewards/rewards.selectors';
import { selectUser } from './user/user.selectors';

export const loyaltySelectors = {
  selectAppliedLoyaltyRewards,
  selectAppliedLoyaltyRewardsArray,
  selectAvailableLoyaltyRewardsMap,
  selectIsPricingRewardApplication,
  selectStagedCartPoints,
  selectTotalTimesRewardApplied,
  selectUser,
};
